import binder from '../resources/mentors/binder.jpg'
import ana from '../resources/mentors/ana.jpg'
import mari from '../resources/mentors/mari.jpg'
import afonso from '../resources/mentors/afonso.jpg'
import flora from '../resources/mentors/flora.jpg'

import maicris from '../resources/mentors/maicris.jpg'
import mark from '../resources/mentors/mark.jpg'
import veloso from '../resources/mentors/veloso.jpg'

import munhoz from '../resources/mentors/munhoz.jpg'
import theo from '../resources/mentors/theo.jpg'
import gonzatto from '../resources/mentors/gonzatto.jpg'

const mentors = [
  {
    name: 'Fabio Binder',
    description: 'Coordenador ⭐️ do projeto, Mentor de Programação',
    image: binder,
    linkedin: 'https://www.linkedin.com/in/binder/',
  },
  {
    name: 'Maicris Fernandes',
    description: 'Mentor de Programação',
    image: maicris,
    linkedin: 'https://www.linkedin.com/in/maicris/?locale=en',
  },
  {
    name: 'Mark Joselli',
    description: 'Mentor de Programação, Responsável pelo Academy Masters',
    image: mark,
    linkedin: '#',
  },
  {
    name: 'Ana C Costa',
    description: 'Mentora de Design/UX',
    image: ana,
    linkedin: 'https://www.linkedin.com/in/ana-carolina-s-costa/',
  },
  {
    name: 'Luiz Veloso',
    description: 'Mentor de Negócios e Programação',
    image: veloso,
    linkedin: 'https://www.linkedin.com/in/lzveloso/',
  },
  {
    name: 'Rodrigo Gonzatto',
    description: 'Mentor de Design/UX',
    image: gonzatto,
    linkedin: 'https://www.linkedin.com/in/gonzatto/',
  },
  {
    name: 'Afonso Rekbaim',
    description: 'Mentor Jr. de Programação',
    image: afonso,
    linkedin: 'https://www.linkedin.com/in/afonsorek/',
  },
  {
    name: 'Flora Koti',
    description: 'Mentora Jr. de Design/UX',
    image: flora,
    linkedin: 'https://www.linkedin.com/in/florakoti/?locale=en',
  },

  {
    name: 'Gustavo Munhoz',
    description: 'Mentor Jr. de Programação',
    image: munhoz,
    linkedin: 'https://www.linkedin.com/in/gmcorrea/',
  },
  {
    name: 'Mariana Lukasinski',
    description: 'Mentora Jr. de Design/UX',
    image: mari,
    linkedin: 'https://www.linkedin.com/in/marianalukasinski/',
  },

  {
    name: 'Theo H Velasco',
    description: 'Mentor Jr. de Design/UX',
    image: theo,
    linkedin: 'https://www.linkedin.com/in/theohenriquevelasco/',
  },
]

export default mentors
